import { Component, Input } from '@angular/core';
import { CalculatorResult } from '../../../../models/analysis/solar-calculator-result';

@Component({
  selector: 'psc-analysis-table',
  templateUrl: './analysis-table.component.html',
  styleUrls: ['analysis-table.component.scss'],
})
export class AnalysisTableComponent {
  headers: string[] = Array(4).fill("FNE");

  cssClasses = '[&>*:not(:nth-child(3))]:bg-yellow2 [&>*:nth-child(3)]:bg-roof-orange';

  @Input() solarCalculatorResult: CalculatorResult;
}
